import commonConstant from '../../common/_commonConstant';

export const iotDevices = (state, action) => {
  switch (action.type) {
    case commonConstant.GET_IOT_DEVICES_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.GET_IOT_DEVICES_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const publishIoTInformation = (state, action) => {
  switch (action.type) {
    case commonConstant.PUBLISH_IOT_INFORMATION_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.PUBLISH_IOT_INFORMATION_FAILURE:
      return Object.assign({}, state, { ...action });
    default:
      return state ? state : {};
  }
};
